import { gql } from "@apollo/client"
import {
  SELLABLE_ITEM_DETAILS_FRAG,
  SELLABLE_ITEM_STOCK_DETAIL_FRAG,
} from "./sellable-item.fragments.gql"

export const ADD_UPDATE_SELLABLE_ITEM = gql`
  mutation SellableItemAddUpdate(
    $codename: String
    $id: ID
    $itemGroups: [ID]
    $longDescription: String
    $name: String
    $photos: [MediaInput]
    $primaryPhoto: MediaInput
    $sellableVarieties: [SellableVarietyInput]
    $shortDescription: String
    $transportationType: String
    $secondarySkuType: ID
    $metadata: SellableItemMetadataInput
    $allowedDepartments: [Int]
    $currentStockPercentage: CustomGenericScalar
  ) {
    addUpdateSellableItem(
      codename: $codename
      id: $id
      itemGroups: $itemGroups
      longDescription: $longDescription
      name: $name
      photos: $photos
      primaryPhoto: $primaryPhoto
      sellableVarieties: $sellableVarieties
      shortDescription: $shortDescription
      transportationType: $transportationType
      secondarySkuTypeId: $secondarySkuType
      allowedDepartments: $allowedDepartments
      metadata: $metadata
      currentStockPercentage: $currentStockPercentage
    ) {
      sellableItem {
        ...SellableItemDetailsFrag
      }
    }
  }
  ${SELLABLE_ITEM_DETAILS_FRAG}
`

export const ADD_UPDATE_SELLABLE_ITEM_STOCK = gql`
  mutation SellableItemStockaddUpdate(
    $currentStockCount: Int!
    $discountedRate: Float!
    $distributionCentreId: ID!
    $groupVisibility: [ID]
    $holdStockCount: Int
    $id: ID
    $isLive: Boolean!
    $offerStockCount: Int!
    $orderingConditions: OrderingConditionInput
    $sellableItemId: ID!
    $unitRate: Float!
    $minRate: Float
    $maxRate: Float
    $relatedStockId: ID
    $expiryDate: Date
    $currentStockPercentage: CustomGenericScalar
    $currentStockType: String
  ) {
    addUpdateSellableItemStock(
      currentStockCount: $currentStockCount
      discountedRate: $discountedRate
      distributionCentreId: $distributionCentreId
      groupVisibility: $groupVisibility
      holdStockCount: $holdStockCount
      relatedStockId: $relatedStockId
      id: $id
      isLive: $isLive
      offerStockCount: $offerStockCount
      orderingConditions: $orderingConditions
      sellableItemId: $sellableItemId
      unitRate: $unitRate
      minRate: $minRate
      expiryDate: $expiryDate
      maxRate: $maxRate
      currentStockPercentage: $currentStockPercentage
      currentStockType: $currentStockType
    ) {
      sellableItemStock {
        sellableItem {
          id
          sellableStocks {
            id
            rejectedStockCount
            bookedStockCount
            currentStockCount
            holdStockCount
            offerStockCount
          }
        }
        ...SellableItemStockDetailFrag
      }
    }
  }
  ${SELLABLE_ITEM_STOCK_DETAIL_FRAG}
`
